import { FunctionComponent, ReactEventHandler } from 'react';
import styled from 'styled-components';

const StyledIframe = styled('iframe')`
  border: 1px solid black;
  border-bottom-width: thin;
  border-color: rgba(145, 158, 171, 0.24);
  border-radius: 1px;
  height: 100%;
  width: 100%;
`;

export type DonorFrameProps = {
  url: string;
};

export const DonorFrame: FunctionComponent<DonorFrameProps> = (props) => {
  const { url } = props;
  const onLoaded: ReactEventHandler<HTMLIFrameElement> = (_event) => {
    return;
  };

  return <StyledIframe src={url} onLoad={onLoaded} />;
};
